module.exports = __webpack_public_path__ + "img/3.c10b10f1.jpg";